import { useEffect } from 'react';

function createPHCCookie(name, value, expirationDays) {
  var date = new Date();
  date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + date.toUTCString();
  var domainParts = window.location.hostname.split('.');
  var topLevelDomain = '.' + domainParts.slice(-2).join('.');
  var domain = "domain=" + topLevelDomain;
  document.cookie = name + "=" + value + ";" + expires + ";path=/;" + domain;
}

function checkPHCParameter() {
  var urlParams = new URLSearchParams(window.location.search);
  var phcValue = urlParams.get('PHC');

  if (phcValue) {
    createPHCCookie('PHC', phcValue, 365);

    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://cors-proxy.planhub.workers.dev/identify?dyn=1&id=' + phcValue + '&provider=beanfield', true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send();
  }
}

export default function PlanHubPageview() {
    useEffect(() => {
      if (typeof window === 'undefined') return;
      if (document.readyState !== 'loading') {
        // The document is already in a ready state, so execute your code immediately.
        checkPHCParameter();
      } else {
        // The document is still loading, so add an event listener for DOMContentLoaded.
        document.addEventListener('DOMContentLoaded', checkPHCParameter);
      }
    }, []);

    return null;
};